/**
 * Converts bool to int
 * @param {Boolean} status
 */
export const convertStatusToInt = status => {
  switch (status) {
    case false:
      return 2;
    case true:
      return 1;
    default:
      return 0;
  }
};



// WEBPACK FOOTER //
// ./src/pages/universaldataexport/helpers/index.js